import { render } from "./ProviderLogoGrid.vue?vue&type=template&id=96444f0a&scoped=true&ts=true"
import script from "./ProviderLogoGrid.vue?vue&type=script&lang=ts"
export * from "./ProviderLogoGrid.vue?vue&type=script&lang=ts"

import "./ProviderLogoGrid.vue?vue&type=style&index=0&id=96444f0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96444f0a"]])

export default __exports__